import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
const _excluded = ["children", "heightPercentage"];
import { Box, styled } from '@migros/msrc-ui-kit';
import React from 'react';
export const FixedRatioContainer = _ref => {
  let {
      children,
      heightPercentage = '100%'
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledFixedRatioContainer, {
    heightPercentage: heightPercentage,
    overflow: ['hidden'],
    position: ['relative']
  }, /*#__PURE__*/React.createElement(Box, _extends({
    position: ['absolute'],
    top: ['0'],
    right: ['0'],
    bottom: ['0'],
    left: ['0']
  }, rest), children));
};
const StyledFixedRatioContainer = styled(Box)`
  height: 0;
  padding-bottom: ${({
  heightPercentage
}) => heightPercentage};
`;